module.exports = __webpack_public_path__ + "fonts/SalesforceSans-Light.2edec8788fdf09212e4fecdfeed96a7e.woff";